import React from 'react';
import { Input } from 'components/Atoms';
import Icon, { SearchIcon } from 'components/Atoms/Icon';
import classnames from 'classnames';

import './styles.scss';

const SearchInput = ({ className, ...rest }) => {
  return (
    <Input
      {...rest}
      prefix={<Icon component={SearchIcon} className="my-search-icon" />}
      className={classnames('search-input', className)}
    />
  );
};

export default SearchInput;
